//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * ResetSessionExpiry
     * @return Session expiry in seconds retrieved successfully
     */
    resetsessionexpiry(): Promise<ApiResponse<number>> {
        let url_ = this.baseUrl + "/session/reset-expiry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetsessionexpiry(_response);
        });
    }

    protected processResetsessionexpiry(response: Response): Promise<ApiResponse<number>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 408) {
            return response.text().then((_responseText) => {
            let result408: any = null;
            result408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Session expired", status, _responseText, _headers, result408);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<number>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetAddresses
     * @param query The search term to apply onto the address to filter on.
     * @return The addresses matching the filter.
     */
    getaddresses(query: string): Promise<ApiResponse<AddressSummary[]>> {
        let url_ = this.baseUrl + "/addresses?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetaddresses(_response);
        });
    }

    protected processGetaddresses(response: Response): Promise<ApiResponse<AddressSummary[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressSummary[];
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<AddressSummary[]>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetPaymentReferenceData
     * @return Reference data response
     */
    getpaymentreferencedata(): Promise<ApiResponse<PaymentReferenceDataResponse>> {
        let url_ = this.baseUrl + "/policies/reference-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetpaymentreferencedata(_response);
        });
    }

    protected processGetpaymentreferencedata(response: Response): Promise<ApiResponse<PaymentReferenceDataResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentReferenceDataResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<PaymentReferenceDataResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * RetrieveQuote
     * @param quoteNumber The unique number for the quote
     * @param suburbName The suburb name
     * @param postcode The postal code for the suburb of the associate quote
     * @return The quote details.
     */
    retrievequote(quoteNumber: string, suburbName: string, postcode: string): Promise<ApiResponse<RetrieveQuoteResponse>> {
        let url_ = this.baseUrl + "/retrieve-quote?";
        if (quoteNumber === undefined || quoteNumber === null)
            throw new Error("The parameter 'quoteNumber' must be defined and cannot be null.");
        else
            url_ += "quoteNumber=" + encodeURIComponent("" + quoteNumber) + "&";
        if (suburbName === undefined || suburbName === null)
            throw new Error("The parameter 'suburbName' must be defined and cannot be null.");
        else
            url_ += "suburbName=" + encodeURIComponent("" + suburbName) + "&";
        if (postcode === undefined || postcode === null)
            throw new Error("The parameter 'postcode' must be defined and cannot be null.");
        else
            url_ += "postcode=" + encodeURIComponent("" + postcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRetrievequote(_response);
        });
    }

    protected processRetrievequote(response: Response): Promise<ApiResponse<RetrieveQuoteResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RetrieveQuoteResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<RetrieveQuoteResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * YourRegistration
     * @param yourRegistrationRequest (optional) The details of the quote to update.
     * @return The updated quote details.
     */
    yourregistration(yourRegistrationRequest?: YourRegistrationRequest | null | undefined): Promise<ApiResponse<QuoteResponse>> {
        let url_ = this.baseUrl + "/your-registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(yourRegistrationRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processYourregistration(_response);
        });
    }

    protected processYourregistration(response: Response): Promise<ApiResponse<QuoteResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuoteResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<QuoteResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * StartDate
     * @param startDateRequest (optional) The details of the quote to update.
     * @return The updated quote details.
     */
    startdate(startDateRequest?: StartDateRequest | null | undefined): Promise<ApiResponse<QuoteResponse>> {
        let url_ = this.baseUrl + "/start-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(startDateRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartdate(_response);
        });
    }

    protected processStartdate(response: Response): Promise<ApiResponse<QuoteResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuoteResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<QuoteResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetAgents
     * @return Web Chat Contact ID Response
     */
    getagents(): Promise<ApiResponse<WebChatContactIdResponse>> {
        let url_ = this.baseUrl + "/agents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetagents(_response);
        });
    }

    protected processGetagents(response: Response): Promise<ApiResponse<WebChatContactIdResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebChatContactIdResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<WebChatContactIdResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * UpdateMember
     * @param member (optional) The details used to patch members.
     * @return Update was successfully executed.
     */
    updatemember(member?: Member | null | undefined): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/members";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(member);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatemember(_response);
        });
    }

    protected processUpdatemember(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too many requests.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetSessionExpiry
     * @return Session expiry in seconds retrieved successfully
     */
    getsessionexpiry(): Promise<ApiResponse<string>> {
        let url_ = this.baseUrl + "/session/expiry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetsessionexpiry(_response);
        });
    }

    protected processGetsessionexpiry(response: Response): Promise<ApiResponse<string>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 408) {
            return response.text().then((_responseText) => {
            let result408: any = null;
            result408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Session expired", status, _responseText, _headers, result408);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<string>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * MoreBoat
     * @param moreBoatRequest (optional) The information capture on the More Boat page.
     * @return The quote details.
     */
    moreboat(moreBoatRequest?: MoreBoatRequest | null | undefined): Promise<ApiResponse<QuoteResponse>> {
        let url_ = this.baseUrl + "/more-boat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moreBoatRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoreboat(_response);
        });
    }

    protected processMoreboat(response: Response): Promise<ApiResponse<QuoteResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuoteResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<QuoteResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * Policies
     * @param policiesRequest (optional) Issue the policy in Shield for payment
     * @return Issue policy using payment method was successful
     */
    policies(policiesRequest?: PoliciesRequest | null | undefined): Promise<ApiResponse<PoliciesResponse>> {
        let url_ = this.baseUrl + "/policies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policiesRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPolicies(_response);
        });
    }

    protected processPolicies(response: Response): Promise<ApiResponse<PoliciesResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PoliciesResponse;
            return new ApiResponse(status, _headers, result201);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PoliciesResponse;
            return new ApiResponse(status, _headers, result204);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PoliciesResponse;
            return throwException("Request entity was unprocessable. Requests may be retried again (with presence of Retry-After header).", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<PoliciesResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * CreateSession
     * @return Session creation was successful
     */
    createsession(): Promise<ApiResponse<string>> {
        let url_ = this.baseUrl + "/session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatesession(_response);
        });
    }

    protected processCreatesession(response: Response): Promise<ApiResponse<string>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<string>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * EmailQuote
     * @param emailQuoteRequest (optional) The details of the quote to be saved and emailed.
     * @return No content
     */
    emailquote(emailQuoteRequest?: EmailQuoteRequest | null | undefined): Promise<ApiResponse<void>> {
        let url_ = this.baseUrl + "/email-quote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailQuoteRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailquote(_response);
        });
    }

    protected processEmailquote(response: Response): Promise<ApiResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new ApiResponse(status, _headers, null as any);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<void>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * YourQuote
     * @param yourQuoteRequest (optional) The details of the quote to update.
     * @return The updated quote details.
     */
    yourquote(yourQuoteRequest?: YourQuoteRequest | null | undefined): Promise<ApiResponse<QuoteResponse>> {
        let url_ = this.baseUrl + "/your-quote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(yourQuoteRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processYourquote(_response);
        });
    }

    protected processYourquote(response: Response): Promise<ApiResponse<QuoteResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuoteResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<QuoteResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetHealthStatus
     * @return Health Status Response
     */
    gethealthstatus(): Promise<ApiResponse<SystemHealthInformation>> {
        let url_ = this.baseUrl + "/health/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGethealthstatus(_response);
        });
    }

    protected processGethealthstatus(response: Response): Promise<ApiResponse<SystemHealthInformation>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SystemHealthInformation;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content Success", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<SystemHealthInformation>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetReferenceData
     * @return All available reference data
     */
    getreferencedata(): Promise<ApiResponse<ReferenceDataResponse>> {
        let url_ = this.baseUrl + "/reference-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetreferencedata(_response);
        });
    }

    protected processGetreferencedata(response: Response): Promise<ApiResponse<ReferenceDataResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReferenceDataResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Client error - bad request", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Authorization error", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<ReferenceDataResponse>>(new ApiResponse(status, _headers, null as any));
    }

    /**
     * GetWebChatContactId
     * @return Web Chat Contact ID Response
     */
    getwebchatcontactid(): Promise<ApiResponse<WebChatContactIdResponse>> {
        let url_ = this.baseUrl + "/web-chat/contact-id";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetwebchatcontactid(_response);
        });
    }

    protected processGetwebchatcontactid(response: Response): Promise<ApiResponse<WebChatContactIdResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebChatContactIdResponse;
            return new ApiResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("An unexpected technical exception has occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse<WebChatContactIdResponse>>(new ApiResponse(status, _headers, null as any));
    }
}

/** Contains the details regarding the error. */
export interface ErrorDto {
    /** The error message. */
    message: string;
}

/** The contacts gender. */
export enum Gender {
    Male = "Male",
    Female = "Female",
}

/** The response of the health status. */
export interface SystemHealthInformation {
    /** The version of the system. */
    version?: string | undefined;
    /** Collection of system dependencies */
    healthStatus?: HealthStatus[] | undefined;
}

/** Health status of a system */
export interface HealthStatus {
    /** The system. */
    system?: string | undefined;
    /** Denotes if the system is alive. */
    isAlive?: boolean | undefined;
    /** The version of the system. */
    version?: string | undefined;
}

/** A request to issue a policy */
export interface PoliciesRequest {
    /** The payment frequency. */
    frequency: PaymentFrequency;
    /** The payment method. */
    method: PaymentMethod;
    /** The accounts BSB number. */
    bsb?: string | undefined;
    /** The account number. */
    accountNumber?: string | undefined;
    /** The account name. */
    accountName?: string | undefined;
    /** The Westpac single use token. */
    token?: string | undefined;
}

/** Contains the number of the policy issued and payment confirmation details. */
export interface PoliciesResponse {
    /** The policy number. */
    policyNumber: string;
    /** The receipt number. */
    receiptNumber?: string | undefined;
    /** The total paid. */
    total?: number | undefined;
}

/** The policyholder's details. */
export interface Policyholder {
    /** The date of birth of the policyholder. */
    dateOfBirth: Date;
}

/** Contains the address summary. */
export interface AddressSummary {
    /** The moniker representing the address. */
    moniker: string;
    /** The display text of the address. */
    displayAddress: string;
}

/** The query parameters for updating a contact. */
export interface Member {
    title: Title;
    gender: Gender;
    /** The first name of the contact. */
    firstName: string;
    /** The middle name of the contact. */
    middleName?: string | undefined;
    /** The contacts surname. */
    surname: string;
    /** The date of birth of the contact. */
    dateOfBirth: Date;
    /** The mobile number of the contact. */
    contactNumber: string;
    /** The email address of the contact. */
    email: string;
    /** The moniker representing the address. */
    mailingAddress: string;
}

/** A suburb in WA with postcode from Shield. */
export interface Suburb {
    /** The display name (Name - Postcode). */
    cityName: string;
    /** The suburb name. */
    name: string;
    /** The suburb postcode */
    postcode: string;
}

/** The contacts title. */
export enum Title {
    Mr = "Mr",
    Mrs = "Mrs",
    Miss = "Miss",
    Ms = "Ms",
    Mx = "Mx",
    Dr = "Dr",
}

export interface DateRange {
    /** The current value. */
    value: Date;
    /** The minimum allowed value. */
    min?: Date | undefined;
    /** The maximum allowed value. */
    max?: Date | undefined;
}

export interface NumberRange {
    /** The current value. */
    value: number;
    /** The minimum allowed value. */
    min?: number | undefined;
    /** The maximum allowed value. */
    max?: number | undefined;
}

export interface NumberOptions {
    /** The selected value or option. */
    value: number;
    /** The available set of options to select a value from. */
    options?: number[] | undefined;
}

/** The premium details. */
export interface PremiumDetails {
    /** The annual premium details. */
    annual: AnnualPremium;
    /** The monthly premium details. */
    monthly: MonthlyPremium;
}

/** The cost of premium for the selected risk/policy details. */
export interface Premium {
    /** The total amount including GST component. */
    total: number;
    /** The GST component. */
    gst: number;
    /** The basic component (Basic = Total - Gst - GovernmentCharges). */
    basic: number;
    /** The government charges (stamp duty) component. */
    governmentCharges: number;
}

/** The cost of annual premium for the selected risk/policy details. */
export interface AnnualPremium extends Premium {
}

/** The cost of premium for the selected risk/policy details. */
export interface MonthlyPremium extends Premium {
    /** The monthly instalment amount. */
    instalment: number;
}

export enum PaymentFrequency {
    Annual = "Annual",
    Monthly = "Monthly",
}

export enum PaymentMethod {
    Card = "Card",
    Bank_account = "Bank account",
}

/** The cover details. */
export interface Cover {
    /** The sum insured details. */
    sumInsured: NumberRange;
    /** The excess for the cover. */
    excess: NumberOptions;
    /** The premium details. */
    premiumDetails: PremiumDetails;
}

/** A More Boat Request. */
export interface MoreBoatRequest {
    /** Is the boat financed. */
    isFinanced: boolean;
    /** Manually entered make of the boat. */
    otherMake: string;
    /** Is the boat kept in a garage. */
    isGaraged: boolean;
    /** Does the boat have Nebo security. */
    isSecurityNebo: boolean;
    /** Does the boat have a security hitch. */
    isSecurityHitch: boolean;
    /** Does the boat have an alarm or GPS. */
    isSecurityAlarmGps: boolean;
    /** An array of the external contact numbers for the finance companies. */
    financeCompanies?: string[] | undefined;
    /** The year the boat was built. */
    builtYear: number;
    /** Boat type. */
    boatType: BoatType;
    /** Policyholder's date of birth. */
    dateOfBirth: Date;
    /** Hull construction. */
    hullConstruction: HullConstruction;
    /** Make. */
    make: string;
    /** Motor type. */
    motorType: MotorType;
    /** Postcode. */
    postcode: string;
    /** Skipper experience. */
    skipperExperience: SkipperExperience;
    /** Suburb. */
    suburb: string;
    /** Agreed value. */
    agreedValue: number;
    /** The claims history. */
    claimsHistory?: Claim[] | undefined;
}

/** Your quote request. */
export interface YourQuoteRequest {
    /** The payment frequency. */
    frequency: PaymentFrequency;
    /** The excess. */
    excess: number;
    /** The agreed value. */
    agreedValue: number;
    /** Whether waterskiing and flotation device cover is required. */
    flotationCover: boolean;
    /** Whether racing cover is required. */
    racingCover: boolean;
}

/** Start date request. */
export interface StartDateRequest {
    /** The start date of the policy. */
    startDate: Date;
}

/** Your registration request. */
export interface YourRegistrationRequest {
    /** Boat registration. */
    boatRegistration?: string | undefined;
    /** Trailer registration. */
    trailerRegistration?: string | undefined;
}

/** Object containing the details of the quote created or updated. */
export interface QuoteResponse {
    /** The quote number. */
    quoteNumber: string;
    /** The start date. */
    startDate: DateRange;
    /** The cover for the quote. */
    cover: Cover;
}

/** Object containing the reference data. */
export interface ReferenceDataResponse {
    /** The list of financiers. */
    financiers: Financier[];
    /** The list of claim types. */
    claimTypes: ReferenceDataOption[];
    /** The list of motor types. */
    motorTypes: ReferenceDataOption[];
    /** The list of hull types. */
    hullTypes: ReferenceDataOption[];
    /** The list of suburbs. */
    suburbs: Suburb[];
    /** The list of boat makes. */
    boatMakes: ReferenceDataOption[];
}

/** The boat type */
export enum BoatType {
    PowerBoat = "PowerBoat",
    SailBoat = "SailBoat",
}

/** The boat's motor type */
export enum MotorType {
    Inboard = "Inboard",
    Outboard = "Outboard",
    NoMotor = "NoMotor",
}

/** The boat's hull construction */
export enum HullConstruction {
    Aluminium = "Aluminium",
    Fibreglass = "Fibreglass",
    Glass_reinforced_plastic = "Glass reinforced plastic",
    Plastic = "Plastic",
    Steel = "Steel",
    Wood = "Wood",
}

/** Claim type */
export enum ClaimType {
    Accidental_Damage = "Accidental Damage",
    Accidental_Loss = "Accidental Loss",
    Collision = "Collision",
    Theft_Attempted_Theft = "Theft/Attempted Theft",
    Storm = "Storm",
    Fire = "Fire",
    Other = "Other",
}

/** The number of years skipper's ticket held. */
export enum SkipperExperience {
    Less_than_1_year = "Less than 1 year",
    _12 = "1-2",
    _23 = "2-3",
    _3_ = "3+",
    I_don_t_have_a_skipper_s_ticket = "I don't have a skipper's ticket",
}

/** The number of claims made in the last three years. */
export enum NumberOfClaims {
    _0 = "0",
    _1 = "1",
    _2 = "2",
    _3 = "3",
    _4 = "4",
    _5 = "5",
    _6_ = "6+",
}

/** The security systems installed in the boat */
export enum SecuritySystems {
    Trailer_security_device = "Trailer security device",
    Alarm_or_GPS_tracker = "Alarm or GPS tracker",
    Nebolink = "nebolink",
    No_security = "No security",
}

/** The generic reference data structure. */
export interface ReferenceDataOption {
    /** Reference data option external code. */
    externalCode: string;
    /** Reference data option description. */
    description: string;
}

/** A financier */
export interface Financier {
    /** The internal id of this financier. */
    externalFinancierNumber?: string | undefined;
    /** The name of the financier. */
    financierName?: string | undefined;
}

/** A claim */
export interface Claim {
    /** An array of years the claim has been made. */
    claimedYears: number[];
    /** The external code of the claim type. */
    claimType: ClaimType;
    /** The number of claims made. */
    numberOfClaims: number;
}

/** The payment reference data */
export interface PaymentReferenceDataResponse {
    /** Westpac security token */
    westpacPublishableApiKey?: string | undefined;
}

export interface EmailQuoteRequest extends YourQuoteRequest {
    /** The email address to email the quote to. */
    email: string;
}

/** Object containing the details of the quote created or updated and existing details. */
export interface RetrieveQuoteResponse {
    /** The quote number. */
    quoteNumber: string;
    /** The start date. */
    startDate: DateRange;
    /** The cover for the quote. */
    cover: Cover;
    /** Is the boat financed. */
    isFinanced: boolean;
    /** Manually entered make of the boat. */
    otherMake: string;
    /** Is the boat kept in a garage. */
    isGaraged: boolean;
    /** Does the boat have Nebo security. */
    isSecurityNebo: boolean;
    /** Does the boat have a security hitch. */
    isSecurityHitch: boolean;
    /** Does the boat have an alarm or GPS. */
    isSecurityAlarmGps: boolean;
    /** An array of the external contact numbers for the finance companies. */
    financeCompanies?: string[] | undefined;
    /** The year the boat was built. */
    builtYear: number;
    /** Boat type. */
    boatType: BoatType;
    /** Hull construction. */
    hullConstruction: HullConstruction;
    /** Make. */
    make: string;
    /** Motor type. */
    motorType: MotorType;
    /** Postcode. */
    postcode: string;
    /** Skipper experience. */
    skipperExperience: SkipperExperience;
    /** Suburb. */
    suburb: string;
    /** Agreed value. */
    agreedValue: number;
    /** The claims history. */
    claimsHistory?: Claim[] | undefined;
    /** Does the quote include racing cover */
    isRacingCover?: boolean | undefined;
    /** Does the quote include floatation cover */
    isFlotationCover?: boolean | undefined;
    /** The payment frequency. */
    frequency?: PaymentFrequency | undefined;
    title?: Title | undefined;
    gender?: Gender | undefined;
    /** The first name of the contact. */
    firstName?: string | undefined;
    /** The middle name of the contact. */
    middleName?: string | undefined;
    /** The contacts surname. */
    surname?: string | undefined;
    /** The mobile number of the contact. */
    contactNumber?: string | undefined;
    /** Policyholder's date of birth. */
    dateOfBirth: Date;
    /** The email address of the contact. */
    email?: string | undefined;
    /** The registration of the boat */
    boatRegistration?: string | undefined;
    /** The registration of the trailer */
    trailerRegistration?: string | undefined;
}

/** The response of whether there is a point of contact id for the web chat agent(s) */
export interface WebChatContactIdResponse {
    /** The point of contact id. */
    pointOfContactId: string;
    /** The CRM ID for the member that called this endpoint. */
    crmId: string;
}

export class ApiResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}
